import {Zakletva} from "../../../komponente/zakletva/Zakletva"
import podaci from "./podaci.json"

export default class PartizanskaZakletva extends Zakletva {

  constructor() {
    super(podaci)
  }

}



// WEBPACK FOOTER //
// ./src/hronologija/1941/07-07/Zakletva.js